import React, { useState, useEffect } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { FormController } from '../shared/FormController';
import { $MeterDetails } from '../../services/V2/aurascope';

export function NewMeterModal({ setShow, districtId, saveCallback }) {
    const [model, setModel] = useState<any>();
    const [reset, setReset] = useState<boolean>(false);

    useEffect(() => {
        if(reset) setReset(false)
    }, [reset])

    useEffect(() => {
        setModel({
            districtId: districtId,
            isActive: true
        })
    }, [districtId])

    const handleCancel = () => {
        setShow(false)
    }

    const handleReset = () => {
        setModel({
            districtId: districtId,
            isActive: true
        })
        setReset(true)
    }

    const handleSave = () => {
        saveCallback({...model}, true)
        handleReset()
    }

    if(model === undefined) return null;

    return (
        <Dialog
        open={true}
        onClose={handleCancel}
        aria-labelledby="form-dialog-title"
        >
            <DialogTitle id="form-dialog-title">Add New Meters For Route</DialogTitle>
            <DialogContent>
                {!reset &&
                    <FormController
                        keys={$MeterDetails.properties}
                        disabledKeys={["districtId"]}
                        extraKeys={[]}
                        editMode={true}
                        model={model}
                        setModel={setModel}
                        canReadUserRoles={false}
                        canReadMeters={false}
                        canReadServiceAddresses={false}
                        districtId={districtId} />
                }
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCancel}>
                    Close
                </Button>
                <Button
                    onClick={handleSave}
                    color="primary"
                >
                    Save Meter to Route
                </Button>
                <Button
                    onClick={handleReset}
                >
                    Reset
                </Button>
            </DialogActions>
        </Dialog>
    );
}